module.exports = __webpack_public_path__ + "img/avatar2.e857270a.png";